import React from 'react'
import { faDownload, faPencilAlt } from '@fortawesome/free-solid-svg-icons'
import { ProductImage } from 'app/common/Common'
import { put } from 'client/utils/api-routes.util'
import {
  $DCprimaryColor,
  DcButton,
  DcInput,
  PixelFactoryContext,
  PixelFlexBox,
  PixelIcon,
  PixelText,
} from 'pixel-base'
import { AjaxResponse } from 'rxjs-compat'

import { IProperties } from './ProductLineItem'
import { IPixelFactory } from '../../../../../../decl.d'
interface IProps {
  item: IProperties
  handleUpdate: (data: IProperties) => void
}
const ItemProperty = (props: IProps) => {
  const { item, handleUpdate } = props
  const [editingProperties, setEditingProperties] = React.useState(false)
  const [lineItemProperty, setLineItemProperty] =
    React.useState<IProperties>(item)
  const { showPageLoader, hidePageLoader, showSuccess, showFailure } =
    React.useContext<IPixelFactory>(PixelFactoryContext)
  const ref = React.useRef(null)
  const handleSubmit = () => {
    showPageLoader(ref)
    put(
      `/orders/products/${lineItemProperty.order_detail_id}/property`,
      lineItemProperty,
    ).subscribe((res: AjaxResponse) => {
      hidePageLoader(ref)
      if (res.response.data) {
        handleUpdate(res.response.data)
        showSuccess('Property updated successfully')
      } else {
        showFailure(res.response.error)
      }
      setEditingProperties(false)
    })
  }
  return (
    <PixelFlexBox
      ref={ref}
      className={`item-property${lineItemProperty.odp_id}`}
      style={{
        width: '30%',
        height: 'fit-content',
        textOverflow: 'ellipsis',
        padding: '5px',
        border: '1px solid #e5e5e5',
        borderRadius: '5px',
      }}
    >
      {editingProperties ? (
        <PixelFlexBox flexDirection="column" margin="10px" gap="10px">
          <DcInput
            placeholder="Name"
            height="30px"
            value={lineItemProperty.property_name}
            onChange={(e) => {
              setLineItemProperty({
                ...lineItemProperty,
                property_name: e.target.value,
              })
            }}
          />
          <DcInput
            height="100px !important"
            type={'text'}
            as={'textarea'}
            name={'Message'}
            placeholder={'Message'}
            value={lineItemProperty.property_value}
            onChange={(e) => {
              setLineItemProperty({
                ...lineItemProperty,
                property_value: e.target.value,
              })
            }}
          />
          <PixelFlexBox
            justifyContent="flex-end"
            alignItems="flex-end"
            gap="10px"
          >
            <DcButton variant="primary" size="sm" onClick={handleSubmit}>
              Update
            </DcButton>
            <DcButton
              variant="outline-secondary"
              size="sm"
              onClick={() => {
                setEditingProperties(false)
              }}
            >
              Cancel
            </DcButton>
          </PixelFlexBox>
        </PixelFlexBox>
      ) : (
        <>
          <PixelFlexBox
            flexDirection="column"
            alignItems="flex-start"
            width="90%"
          >
            <PixelText
              textSize="12px"
              style={{
                display: 'flex',
                width: '100%',
                textOverflow: 'ellipsis',
                wordWrap: 'break-word',
                overflow: 'hidden',
                maxHeight: '3.6em',
                lineHeight: '1.8em',
              }}
            >
              <div
                style={{
                  fontSize: '11px',
                  color: 'gray',
                }}
              >
                Name:&nbsp;
              </div>
              {item.property_name}
            </PixelText>
            {item.property_type === 'image' && (
              <PixelFlexBox
                flexDirection="column"
                alignItems="center"
                justifyContent="center"
              >
                <ProductImage
                  style={{
                    width: '38px',
                    height: '38px',
                    marginRight: '5px',
                    marginTop: '5px',
                    borderRadius: '3px',
                    border: '1px solid #e6e6e6',
                  }}
                  path={item.image}
                />
                <PixelText
                  style={{
                    display: 'flex',
                    color: $DCprimaryColor,
                  }}
                >
                  <PixelFlexBox
                    style={{
                      fontSize: '12px',
                      cursor: 'pointer',
                      textDecoration: 'underline',
                    }}
                    onClick={() => {
                      window.open(
                        item.property_value,
                        '_blank',
                        'noopener,noreferrer',
                      )
                    }}
                  >
                    <PixelIcon fontSize={'15px'} icon={faDownload} />
                    &nbsp;
                    <div>Download</div>
                  </PixelFlexBox>
                </PixelText>
              </PixelFlexBox>
            )}
            {item.property_type !== 'image' && (
              <PixelText
                textSize="12px"
                style={{
                  display: 'flex',
                  width: '100%',
                  textOverflow: 'ellipsis',
                  wordWrap: 'break-word',
                  overflow: 'hidden',
                  maxHeight: '3.6em',
                  lineHeight: '1.8em',
                }}
              >
                <div
                  style={{
                    fontSize: '11px',
                    color: 'gray',
                  }}
                >
                  Message:&nbsp;
                </div>
                {item.property_value}
              </PixelText>
            )}
          </PixelFlexBox>
          {item.property_type !== 'image' && (
            <PixelFlexBox
              width="10%"
              height="auto"
              justifyContent="flex-start"
              alignItems="flex-start"
            >
              <PixelText
                style={{
                  display: 'flex',
                  fontSize: '11px',
                  textDecoration: 'underline',
                  cursor: 'pointer',
                  color: $DCprimaryColor,
                }}
                onClick={() => {
                  setEditingProperties(true)
                }}
              >
                <PixelIcon color={$DCprimaryColor} icon={faPencilAlt} />
              </PixelText>
            </PixelFlexBox>
          )}
        </>
      )}
    </PixelFlexBox>
  )
}

export default ItemProperty
